import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

type LazyComp = LazyExoticComponent<ComponentType<any>>;

const AppLoading = lazy(() => import('@repo/ui').then((m) => ({ default: m.AppLoading })));

const DashboardView = lazy(() =>
  import('./components/dashboard/dashboard-view').then((m) => ({
    default: m.DashboardView,
  })),
);

const LoanFormView = lazy(() =>
  import('./components/loan-form/loan-form-view').then((m) => ({
    default: m.LoanFormView,
  })),
);

const ServiceIsNotAvailable = lazy(() =>
  import('./components/welcome/service-not-available/service-not-available').then((m) => ({
    default: m.ServiceIsNotAvailable,
  })),
);

const LoanApplicationPossibleWithSelectedMarketingAgreement = lazy(() =>
  import('./components/welcome/loan-application-possible/loan-application-possible').then((m) => ({
    default: m.LoanApplicationPossibleWithSelectedMarketingAgreement,
  })),
);

const LoanApplicationPossibleWithoutSelectedMarketingAgreement = lazy(() =>
  import('./components/welcome/loan-application-possible/loan-application-possible').then((m) => ({
    default: m.LoanApplicationPossibleWithoutSelectedMarketingAgreement,
  })),
);

const LoanApplicationLowerPrivilegeLevel = lazy(() =>
  import('./components/welcome/loan-application-lower-privilege-level/loan-application-lower-privilege-level').then(
    (m) => ({ default: m.LoanApplicationLowerPrivilegeLevel }),
  ),
);

const UserHasLessThan3000Prelimit = lazy(() =>
  import('./components/welcome/user-has-less-than-3000-prelimit/user-has-less-than-3000-prelimit').then(
    (m) => ({ default: m.UserHasLessThan3000Prelimit }),
  ),
);

const UserHasNoActiveAccount = lazy(() =>
  import('./components/welcome/user-has-no-active-account/user-has-no-active-account').then(
    (m) => ({ default: m.UserHasNoActiveAccount }),
  ),
);

const UserHasZeroPreLimit = lazy(() =>
  import('./components/welcome/user-has-0-pre-limit/user-has-zero-pre-limit').then((m) => ({
    default: m.UserHasZeroPreLimit,
  })),
);

const PragmaProcessIframe = lazy(() =>
  import('./components/welcome/pragma-process-iframe/pragma-process-iframe').then((m) => ({
    default: m.PragmaProcessIframe,
  })),
);

const SelectOfferView = lazy(() =>
  import('./components/select-offer/select-offer-view').then((m) => ({
    default: m.SelectOfferView,
  })),
);

import { ZeroViewType } from './store/view.type';

export const viewZero: Record<ZeroViewType, LazyComp> = {
  SERVICE_NOT_AVAILABLE: ServiceIsNotAvailable,
  LOAN_APPLICATION_POSSIBLE_WITH_SELECTED_MARKETING_DATA:
    LoanApplicationPossibleWithSelectedMarketingAgreement,
  LOAN_APPLICATION_POSSIBLE_WITHOUT_SELECTED_MARKETING_DATA:
    LoanApplicationPossibleWithoutSelectedMarketingAgreement,
  LOAN_APPLICATION_LOWER_PRIVILEGE_LEVEL: LoanApplicationLowerPrivilegeLevel,
  USER_HAS_LESS_THAN_3000_PRELIMIT: UserHasLessThan3000Prelimit,
  USER_HAS_NO_ACTIVE_ACCOUNT: UserHasNoActiveAccount,
  USER_HAS_0_PRELIMIT: UserHasZeroPreLimit,
  PRAGMA_PROCESS_IFRAME: PragmaProcessIframe,
};

const map: Record<string, LazyComp> = {
  APP_LOADING: AppLoading,
  DASHBOARD: DashboardView,
  LOAN_FORM_VIEW: LoanFormView,
  SELECT_OFFER_VIEW: SelectOfferView,
  ...viewZero,
};

if (__IS_TESTMODE_STANDALONE__) {
  map.PLAYGROUND = lazy(() =>
    import('./components/playground/playground').then((m) => ({
      default: m.Playground,
    })),
  );
}

export const renderCurrentView = map;
